<template>
  <div>
    <van-uploader v-model="fileList" :multiple="multiple" :after-read="afterRead" :before-delete="beforeDelete" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
      lists: [],
    }
  },
  methods: {
    getFiles() {
      return this.lists
    },
    clear() {
     this.fileList = []
     this.lists = []
    },
    beforeDelete(v) {
      this.fileList.forEach((item, index) => {
        if (item === v) {
          this.lists = this.lists.filter((item1, index1) => {
            return index !== index1
          })
        }
      })
      return true
    },
    // 上传到服务器
    afterRead(v) {
      let _this = this
      let formData = new FormData()
      formData.append('file', v.file)
      // formData.append('filename', fileUrl)
      this.$api.post('/api-file/file/uploadFile?module=overnightbag&mediaType=', formData).then((res) => {
        if (res.code === '0000') {
          _this.lists.push({ url: res.url, name: res.fileName })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/Upload.vue